/**
 * Pure email format helpers — no server-only deps so client components
 * can import these alongside server-side validation code.
 */

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Validates email format with a pragmatic regex (rejects whitespace and
 * requires `local@domain.tld` shape). Not RFC 5322 strict.
 */
export function isValidEmail(email: string): boolean {
  return EMAIL_REGEX.test(email);
}

// Printable-ASCII-only range, so it never trips no-control-regex.
const NON_ASCII_REGEX = /[^\x20-\x7E]/;

/**
 * True for a single ASCII `local@domain.tld` address with no commas or
 * whitespace — the strict single-recipient variant for Resend `to` fields
 * (#3411). Tightens EMAIL_REGEX on exactly the two axes Resend 422s on
 * ("Invalid `to` field"): commas (which `[^\s@]` permits inside the domain,
 * and which Resend reads as an address-list separator) and non-ASCII
 * (rejected since PR #3322). Kept separate from isValidEmail so auth/invite
 * forms (#3316 call sites) keep their current, slightly looser validation.
 */
export function isValidAsciiEmail(email: string): boolean {
  return EMAIL_REGEX.test(email) && !email.includes(',') && !NON_ASCII_REGEX.test(email);
}
